import React, { FC } from 'react';
import styled from 'styled-components/macro';
export const Hamburger: FC<{ open?: boolean; onClick?: () => void; className?: string; transitionTime?: string }> = ({
    open,
    onClick,
    className,
    transitionTime,
}) => {
    const classNameArr = [...(className ? [className] : []), ...(open ? ['open'] : [])];
    const classNames = classNameArr.join(' ');
    return (
        <NavIcon
            scale={0.375}
            className={classNames}
            onClick={() => onClick?.()}
            transitionTime={transitionTime || '0.25s'}
        >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </NavIcon>
    );
};

const NavIcon = styled.div<{ scale: number; transitionTime: string }>`
    width: ${(props) => props.scale * 60}px;
    height: ${(props) => props.scale * 45}px;
    position: relative;
    transform: rotate(0deg);
    transition: ${(props) => props.transitionTime} ease-in-out;
    cursor: pointer;
    display: inline-block;
    span {
        display: block;
        position: absolute;
        height: ${(props) => props.scale * 9}px;
        width: 100%;
        background: ${(props) => props.theme.colors.widgets.color};
        border-radius: ${(props) => props.scale * 9}px;
        opacity: 1;
        left: 0;
        transform: rotate(0deg);
        transition: calc(${(props) => props.transitionTime} / 2) ease-in-out;
        &:nth-child(1) {
            top: 0px;
        }

        &:nth-child(2),
        &:nth-child(3) {
            top: ${(props) => props.scale * 18}px;
        }

        &:nth-child(4) {
            top: ${(props) => props.scale * 36}px;
        }
    }
    &.open {
        span {
            &:nth-child(1) {
                top: ${(props) => props.scale * 18}px;
                width: 0%;
                left: 50%;
            }

            &:nth-child(2) {
                transform: rotate(45deg);
            }

            &:nth-child(3) {
                transform: rotate(-45deg);
            }

            &:nth-child(4) {
                top: ${(props) => props.scale * 18}px;
                width: 0%;
                left: 50%;
            }
        }
    }
`;
